import React from 'react';

import { List } from './styles';

type Props = {
  children?: React.ReactNode;
  embedded?: boolean;
};

const MenuList = ({ children, embedded = false }: Props) => <List $embedded={embedded}>{children}</List>;

export default MenuList;
